import { Code } from '@atlaskit/code';
import { DoDont } from '@af/design-system-docs-ui/do-dont';
import { DoDontGrid } from '@af/design-system-docs-ui/do-dont-grid';
import rovoActionsDark from "../../../../src/pages/rovo-ui/elevation/_assets/rovo-actions-dark.png";
import rovoActionsLight from "../../../../src/pages/rovo-ui/elevation/_assets/rovo-actions-light.png";
import rovoElevationDark from "../../../../src/pages/rovo-ui/elevation/_assets/rovo-elevation-dark.png";
import rovoElevationLight from "../../../../src/pages/rovo-ui/elevation/_assets/rovo-elevation-light.png";
import rovoMenuDark from "../../../../src/pages/rovo-ui/elevation/_assets/rovo-menu-dark.png";
import rovoMenuLight from "../../../../src/pages/rovo-ui/elevation/_assets/rovo-menu-light.png";
import rovoMenuDoDark from "../../../../src/pages/rovo-ui/elevation/_assets/rovo-menu-do-dark.png";
import rovoMenuDoLight from "../../../../src/pages/rovo-ui/elevation/_assets/rovo-menu-do-light.png";
import rovoMenuDontDark from "../../../../src/pages/rovo-ui/elevation/_assets/rovo-menu-dont-dark.png";
import rovoMenuDontLight from "../../../../src/pages/rovo-ui/elevation/_assets/rovo-menu-dont-light.png";
import rovoOverlayRemixDark from "../../../../src/pages/rovo-ui/elevation/_assets/rovo-overlay-remix-dark.png";
import rovoOverlayRemixLight from "../../../../src/pages/rovo-ui/elevation/_assets/rovo-overlay-remix-light.png";
import rovoOverlayRemix2Dark from "../../../../src/pages/rovo-ui/elevation/_assets/rovo-overlay-remix2-dark.png";
import rovoOverlayRemix2Light from "../../../../src/pages/rovo-ui/elevation/_assets/rovo-overlay-remix2-light.png";
import * as React from 'react';
export default {
  Code,
  DoDont,
  DoDontGrid,
  rovoActionsDark,
  rovoActionsLight,
  rovoElevationDark,
  rovoElevationLight,
  rovoMenuDark,
  rovoMenuLight,
  rovoMenuDoDark,
  rovoMenuDoLight,
  rovoMenuDontDark,
  rovoMenuDontLight,
  rovoOverlayRemixDark,
  rovoOverlayRemixLight,
  rovoOverlayRemix2Dark,
  rovoOverlayRemix2Light,
  React
};